import './winmock5/style';
import FormStructure from './winmock5/form_structure';

export default FormStructure;